import { render, staticRenderFns } from "./PdSection.vue?vue&type=template&id=33d15dd1&scoped=true&"
import script from "./PdSection.vue?vue&type=script&lang=js&"
export * from "./PdSection.vue?vue&type=script&lang=js&"
import style0 from "./PdSection.vue?vue&type=style&index=0&id=33d15dd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d15dd1",
  null
  
)

export default component.exports